export default {
order_history: "Order History",
all_status: "All Status",
placed: "Placed",
accepted: "Accepted",
packed: "Packed",
delivered: "Delivered",
rejected: "Rejected",

all_payments: "All Payments",
paid: "Paid",
unpaid: "Unpaid",
payment_partial: "Partial payment",

all_amounts: "All Amounts",
search_orders: "Search by Order ID or Restaurant...",

order_id: "Order ID",
restaurant: "Restaurant",
date: "Date",
total: "Total",
status: "Status",
payment_type: "Payment Type",
payment: "Payment",
action: "Action",

view: "View",
chat: "Chat",
no_orders: "No orders found",

// STATUS KEYS
status_placed: "Placed",
status_accepted: "Accepted",
status_packed: "Packed",
status_out_for_delivery: "Out for Delivery",
status_delivered: "Delivered",
status_rejected: "Rejected",

method_cod: "Cash on Delivery",
method_online: "Online Payment",
method_credit: "Credit",

payment_paid: "Paid",
payment_pending: "Pending",
payment_unpaid: "Unpaid",

currency_code: "QAR",
price_0_100: "QAR 0 – QAR 100",
price_100_500: "QAR 100 – QAR 500",
price_500_1000: "QAR 500 – QAR 1,000",
price_1000_5000: "QAR 1,000 – QAR 5,000",
price_5000_plus: "QAR 5,000+",
recurring: "Recurring",
order_details: "Order Details",
order_modification: "Order Modification",
recurring: "Recurring",
recurring_details: "Recurring Details",
frequency: "Frequency",
next_run: "Next Run",
start_date: "Start Date",
end_date: "End Date",
skip_today: "Skip Today",

restaurant_details: "Restaurant Details",
name: "Name",
supbranch: "Branch",
contact: "Contact",
mobile: "Mobile",
email: "Email",
supaddress: "Address",

products: "Products",
product: "Product",
qty: "Qty",
price: "Price",
total: "Total",
unit_price: "Unit Price",
remove: "Remove",

modification_reason: "Reason for modification",
send_modification: "Send Modification Request",

order_timeline: "Order Timeline",

accept: "Accept",
reject: "Reject",
mark_packed: "Mark Packed",
view_delivery: "View Delivery Status",
generate_invoice: "Generate Invoice",
view_receipt: "View Receipt",
assign_delivery: "Assign Delivery",
modify_order: "Modify Order",
}